import type { ChipVariant } from '@/components/ui/Chip/Chip'
import { Chip } from '@/components/ui'
import type { DisciplinaryStatus } from '../api/types'

const STATUS_LABELS: Record<DisciplinaryStatus, string> = {
  draft: 'Draft',
  issued: 'Issued',
  acknowledged: 'Acknowledged',
}

const STATUS_VARIANTS: Record<DisciplinaryStatus, ChipVariant> = {
  draft: 'neutral',
  issued: 'warning',
  acknowledged: 'success',
}

interface Props {
  status: DisciplinaryStatus
}

export function DisciplinaryStatusChip({ status }: Props) {
  return (
    <Chip variant={STATUS_VARIANTS[status] ?? 'default'}>
      {STATUS_LABELS[status] ?? status}
    </Chip>
  )
}
